module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getAllBrandSheets()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-cached\n        ")]), _vm._v(" \n        Reload\n      ")], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("\n              mdi-content-copy\n            ")]), _vm._v(" Copy Link\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(action, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.copyBrandSheetLink(action.value)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(action.title))])], 1)
  }), 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-brand-link"
    },
    domProps: {
      "value": _vm.brandSheetLink
    }
  }), _vm._v(" "), (_vm.brandLinkCopied) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "elevation": "0",
      "text": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-check\n        ")]), _vm._v("Copied\n      ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row mt-3",
    staticStyle: {
      "justify-content": "space-between",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Submissions for " + _vm._s(_vm.currentMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalValues.currentMonth)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Total Submissions for " + _vm._s(_vm.currentYearLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalValues.currentYear)))])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.openTotalSubmissionsModal
    }
  }, [_vm._v("\n                More Details\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item.type",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [_vm._v("\n            " + _vm._s(item.type === 'UGC' ? 'UGC Videos' : item.type) + "\n          ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.getBrandSheetDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.downloadBFS(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Download"
          }
        }, [_vm._v("download")])], 1)], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('view-brand-sheet-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "brandSheetData": _vm.viewBrandSheetData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('total-submissions-modal', {
    attrs: {
      "value": _vm.totalSubmissionsModalDialog,
      "monthYearValues": _vm.monthYearValues
    },
    model: {
      value: (_vm.totalSubmissionsModalDialog),
      callback: function($$v) {
        _vm.totalSubmissionsModalDialog = $$v
      },
      expression: "totalSubmissionsModalDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aa37a62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/BrandSheetList.vue
// module id = 2211
// module chunks = 0